// This can be easily modified for different environments
const BASE_URL = ''; // Empty string for relative URLs

export const environment = {
  production: true,
  isMobile: true,
  apiUrl: `${BASE_URL}/api`,
  azureAd: {
    tenantId: 'c8f1586f-d20e-4033-b7eb-6f9c446f089d',
    clientId: '88124053-2712-467e-8618-5cca643a2851',
    redirectUri: 'https://testenv-webapp.icyground-38969c17.eastus2.azurecontainerapps.io',
    scopes: ['openid', 'profile', 'email']
  },
  restrictedAccess: '155f86d6-2909-44ad-b178-b9d39948237a',
  chatOnlyAccess: 'ca215817-2343-4026-b3ca-f2b0adaed5bc',
  uploadAccess: '941f3ed4-c59c-4b84-8fb5-81aa39782bd1'
};

// Debug log to verify environment
console.log('📱 Mobile PRODUCTION Environment Loaded:', environment.apiUrl);
